import * as types from './mutation-types';
import Vue from 'vue';

export const mutations = {
  [types.UPDATE_OWNER] (state, { repos, topics }) {
    Vue.set(state, 'repos', {...repos});
    Vue.set(state, 'topics', {...topics});
    Vue.set(state, 'curCapital', 'All');
    Vue.set(state, 'curTopics', []);
  },
  [types.UPDATE_CAPITAL] (state, capital) {
    Vue.set(state, 'curCapital', capital);
  },
  [types.UPDATE_TOPICS] (state, topics) {
    Vue.set(state, 'curTopics', topics);
  },
  [types.UPDATE_LOADED] (state, loaded) {
    Vue.set(state, 'loaded', loaded);
  },
  [types.UPDATE_LOADING_ERROR] (state, error) {
    Vue.set(state, 'loadingError', error);
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js